import { ApiEndpointConfig } from './api-endpoint-config';

const ENDPOINTS: Record<string, ApiEndpointConfig> = {
  getOrgTierPreferences: {
    method: 'get',
    url: 'org/{orgId}/tier-preferences'
  },
  updateOrgTierPreferences: {
    method: 'put',
    url: 'org/{orgId}/tier-preferences'
  },
  deleteOrgTierPreferences: {
    method: 'delete',
    url: 'org/{orgId}/tier-preferences'
  },
  getAppAvailability: {
    method: 'get',
    url: 'app/{appId}/availability'
  },
  updateAppAvailability: {
    method: 'put',
    url: 'app/{appId}/availability'
  },
  deleteAppAvailability: {
    method: 'delete',
    url: 'app/{appId}/availability'
  },
  activateVisualPreviewKeda: {
    method: 'post',
    url: 'visual-preview/{previewName}/activate-keda',
    showSpinner: false
  },
  activateCompletePreviewKeda: {
    method: 'post',
    url: 'complete-preview/{previewName}/activate-keda',
    showSpinner: false
  },
  activateEditorKeda: {
    method: 'post',
    url: 'online-ide/editor-deployment/{deploymentName}/activate-keda',
    showSpinner: false
  }
};

Object.values(ENDPOINTS).forEach((api) => {
  (api as any).serviceType = 'codeIDE';
});

export const ENVIRONMENT_AVAILABILITY_API_CONSTANTS = ENDPOINTS as typeof ENDPOINTS &
  Record<keyof typeof ENDPOINTS, { serviceType: string }>;
